var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "delivery",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.958,
    height: 28.834,
    viewBox: "0 0 32.958 28.834",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4240",
    "data-name": "Path 4240",
    d: "M55.555,7.508h16.5V22.972h-16.5Zm0,0",
    transform: "translate(-51.979 -7.025)",
    fill: "#ffde7c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4241",
    "data-name": "Path 4241",
    d: "M55.555,7.508h2.577V22.972H55.555Zm0,0",
    transform: "translate(-51.979 -7.025)",
    fill: "#ffc824"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4242",
    "data-name": "Path 4242",
    d: "M162.749,11.632l-1.546-.515-1.546.515V7.508h3.093Zm0,0",
    transform: "translate(-149.379 -7.025)",
    fill: "#ffbd85"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4243",
    "data-name": "Path 4243",
    d: "M87.586,111.609h6.186v2.062H87.586Zm0,0",
    transform: "translate(-81.948 -104.425)",
    fill: "#f0efef"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4244",
    "data-name": "Path 4244",
    d: "M26.58,186.773A6.342,6.342,0,0,0,24,187.8H21.426l-2.577-2.062h3.608v-1.031a1.031,1.031,0,0,0-1.031-1.031H16.786l-2.062,2.062H7.508v3.608h7.217l6.186,1.031,3.608-1.031,3.093-1.546A1.01,1.01,0,0,0,26.58,186.773Zm0,0",
    transform: "translate(-7.025 -171.856)",
    fill: "#ffe9d6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4245",
    "data-name": "Path 4245",
    d: "M194.587,199.7h-3.093l-.013,1.031h3.106Zm0,0",
    transform: "translate(-179.155 -186.841)",
    fill: "#ffd3ae"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4246",
    "data-name": "Path 4246",
    d: "M27.222,234.746l-2.7,1.352-3.608,1.031L14.724,236.1H7.508v1.031h7.217l6.186,1.031,3.608-1.031,3.093-1.546A1.15,1.15,0,0,0,27.222,234.746Zm0,0",
    transform: "translate(-7.025 -219.635)",
    fill: "#ffd3ae"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4247",
    "data-name": "Path 4247",
    d: "M7.508,212.858V207.7h5.67v5.155Zm0,0",
    transform: "translate(-7.025 -194.333)",
    fill: "#ff8660"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4248",
    "data-name": "Path 4248",
    d: "M7.508,263.758h5.67V265.3H7.508Zm0,0",
    transform: "translate(-7.025 -246.779)",
    fill: "#ff6838"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4249",
    "data-name": "Path 4249",
    d: "M277.951,370.117h-2.577a6.342,6.342,0,0,0-2.577-1.031,1.01,1.01,0,0,0-1.031,1.031l3.093,1.546,3.332.952-.146-2.573Zm0,0",
    transform: "translate(-254.272 -345.327)",
    fill: "#ffd3ae"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4250",
    "data-name": "Path 4250",
    d: "M239.183,337.89l-2.062-2.062h-4.639a1.031,1.031,0,0,0-1.031,1.031v1.031h3.093l-4.639,2.062h-2.577a6.342,6.342,0,0,0-2.577-1.031,1.01,1.01,0,0,0-1.031,1.031l3.093,1.546,3.608,1.031,6.186-1.031h5.155V337.89Zm0,0",
    transform: "translate(-209.318 -314.211)",
    fill: "#ffe9d6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4251",
    "data-name": "Path 4251",
    d: "M343.836,351.844h3.093v1.031h-3.093Zm0,0",
    transform: "translate(-321.703 -329.195)",
    fill: "#ffd3ae"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4252",
    "data-name": "Path 4252",
    d: "M230.42,389.278l-3.608-1.031-2.7-1.352a1.15,1.15,0,0,0-.389.837l3.093,1.546,3.608,1.031,6.186-1.031h5.155v-1.031h-5.155Zm0,0",
    transform: "translate(-209.318 -361.99)",
    fill: "#ffd3ae"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4253",
    "data-name": "Path 4253",
    d: "M80.561,104.1a.483.483,0,0,0-.483.483v2.062a.483.483,0,0,0,.483.483h6.186a.483.483,0,0,0,.483-.483v-2.062a.483.483,0,0,0-.483-.483Zm5.7,2.062H81.045v-1.1h5.219Zm0,0",
    transform: "translate(-74.923 -97.4)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4254",
    "data-name": "Path 4254",
    d: "M13.806,19a.5.5,0,0,0,.079.007.485.485,0,0,0,.133-.019l3.608-1.031a.5.5,0,0,0,.083-.032L20.8,16.38a.483.483,0,0,0,.267-.432,1.592,1.592,0,0,0-.515-1.168v-8.9a.483.483,0,1,0-.967,0v8.56h-.032a6.209,6.209,0,0,0-2.72,1.031H14.571l-1.369-1.1h2.231a.483.483,0,0,0,.483-.483V12.855A1.516,1.516,0,0,0,14.4,11.34H9.762a.482.482,0,0,0-.342.142L7.5,13.4H6.637V13.37a.483.483,0,0,0-.483-.483H4.059V.967H9.794v3.64a.488.488,0,0,0,.636.458L11.824,4.6l1.394.464a.488.488,0,0,0,.636-.458V.967h5.735V3.555a.483.483,0,0,0,.967,0V.483A.483.483,0,0,0,20.071,0H3.576a.483.483,0,0,0-.483.483v12.4H.483a.483.483,0,1,0,0,.967H5.67v4.188H.483a.483.483,0,1,0,0,.967h5.67a.483.483,0,0,0,.483-.483v-.548H7.66ZM12.887.967v2.97l-.91-.3a.485.485,0,0,0-.306,0l-.91.3V.967Zm-6.25,13.4H7.7a.491.491,0,0,0,.342-.142l1.92-1.92H14.4a.548.548,0,0,1,.548.548V13.4H11.824a.484.484,0,0,0-.3.861L14.1,16.325a.485.485,0,0,0,.3.106h2.577a.483.483,0,0,0,.268-.081,5.67,5.67,0,0,1,2.309-.95.485.485,0,0,1,.491.277l-2.729,1.364-3.46.989L7.779,17.017l-.014,0-.026,0h-1.1Zm0,0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4255",
    "data-name": "Path 4255",
    d: "M234.268,333.49h-5.2l-.028,0-.015,0-6.071,1.012-3.451-.986-2.7-1.349a.459.459,0,0,1,.449-.23,5.664,5.664,0,0,1,2.291.944.516.516,0,0,0,.286.087h2.577a.513.513,0,0,0,.209-.045l4.63-2.058a.516.516,0,0,0-.211-.991h-2.566v-.515a.516.516,0,0,1,.515-.515h4.426l1.911,1.911a.523.523,0,0,0,.365.151h2.577a.515.515,0,1,0,0-1.031H231.9l-1.911-1.911a.515.515,0,0,0-.365-.151h-4.639a1.548,1.548,0,0,0-1.546,1.546V330.4a.516.516,0,0,0,.515.516h.664l-.178.079h-1.365a6.223,6.223,0,0,0-2.729-1.031,1.484,1.484,0,0,0-1.534,1.357,4.116,4.116,0,0,0-1.559-.4,1.5,1.5,0,0,0-1.546,1.546.516.516,0,0,0,.285.461l3.093,1.546a.51.51,0,0,0,.089.034l3.608,1.031a.511.511,0,0,0,.142.02.536.536,0,0,0,.085-.007l6.144-1.024h5.112a.515.515,0,1,0,0-1.031Zm-14.359-2.268a.42.42,0,0,1,.441-.231,5.353,5.353,0,0,1,2.16.86l-.207.092h-1.095a.514.514,0,0,0-.191-.164l-1.11-.555Zm0,0",
    transform: "translate(-201.825 -306.718)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.d7dce2bbb3b7f6b2c9b00560fc3add95.svg";
export { ForwardRef as ReactComponent };